module.exports = __webpack_public_path__ + "img/works_beijing_xikemu_4.f62aeed2.jpg";